import * as d3 from 'd3'
export default {
  methods: {

    draw_Image() {

      let detailImage = this.canvasForm
      .append('g')
      .attr('id', `SYS_SVG`)
      .attr('transform', `translate(450, 80) scale(.9)`)
      .attr('opacity', 1)

      // Forms for Overall
      this.loadSvg(
        detailImage, {
        x   : 0,
        y   : 0,

        url : this.HOST + `/SystemCompletion/SystemBoundary/${this.revision}/svg/9903.svg`
      }).then(() => {
        d3.select(`#SYS_SVG`).attr('transform', `translate(${450+this.image.x}, ${80+this.image.y}) scale(${this.image.scale})`)
      })

    },


    reflashSVG(sys) {


      d3.select(`#SYS_SVG`).transition().duration(300).attr('opacity', 0)
        
      setTimeout(() => {

        d3.select(`#SYS_SVG`).remove()

        let detailImage = this.canvasForm
        .append('g')
        .attr('id', `SYS_SVG`)
        .attr('transform', `translate(450, 80) scale(.9)`)
        .attr('opacity', 1)

        // Forms for Overall
        this.loadSvg(
          detailImage, {
          x   : 0,
          y   : 0,

          url : this.HOST + `/SystemCompletion/SystemBoundary/${this.revision}/svg/${sys}.svg`
          }).then(() => {
            d3.select(`#SYS_SVG`).attr('transform', `translate(${450+this.image.x}, ${80+this.image.y}) scale(${this.image.scale})`)
            d3.select(`#SYS_SVG`).attr('opacity', 0)
            d3.select(`#SYS_SVG`).transition().duration(500).attr('opacity', 1)
          }
        )
      })

    },

  }
}
